import { render, staticRenderFns } from "./SchoolNavs.vue?vue&type=template&id=b68152fc&scoped=true"
import script from "./SchoolNavs.vue?vue&type=script&lang=js"
export * from "./SchoolNavs.vue?vue&type=script&lang=js"
import style0 from "./SchoolNavs.vue?vue&type=style&index=0&id=b68152fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_71321242e37ff7a0c7584d931db29eba/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68152fc",
  null
  
)

export default component.exports